import {Payment} from "./payment";
import {Utils} from "../shared/utils/utils";

export class PaymentMapper {

  public static map(data: any): Payment {
    let payment: Payment = new Payment();
    payment.id = data.id;
    payment.agreementId = data.agreements_id;
    payment.totalAmount = data.formated_payment_amount? data.formated_payment_amount.formatted : data.payment_amount;
    payment.paymentStatus = data.payment_status;
    payment.paymentType = data.payment_type;
    payment.cardType = data.card_type.toLowerCase() === "american express" ? 'amex' : data.card_type.toLowerCase();
    payment.cardLastNumbers = data.card_last_numbers;
    payment.invoiceId = data.invoice_id;
    payment.invoicePath = data.invoice_path;
    payment.subscriptionTitle = data.subscription_title;
    payment.paymentsDate = data.payment_date ? Utils.formatPaymentDate(data.payment_date) : null;
    return payment;
  }

}
